import { render, staticRenderFns } from "./JGraphicCode.vue?vue&type=template&id=4a4f71ae&scoped=true"
import script from "./JGraphicCode.vue?vue&type=script&lang=js"
export * from "./JGraphicCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f71ae",
  null
  
)

export default component.exports